import React from "react";
import logo from "./logo.svg";
import call from "./Call.svg";
import './Navbar.css';

export const Navbar = () => {
	return (
		<nav className="navbar navbar-expand-lg bg-body-tertiary">
			<div className="container-fluid">
				<a className="navbar-brand ms-3" href="#">
					<img src={logo} alt="Bootstrap" width="180" height="79"></img>
				</a>
				<button
					className="navbar-toggler"
					type="button"
					data-bs-toggle="collapse"
					data-bs-target="#navbarSupportedContent"
					aria-controls="navbarSupportedContent"
					aria-expanded="false"
					aria-label="Toggle navigation">
					<span className="navbar-toggler-icon"></span>
				</button>
				<div className="collapse navbar-collapse" id="navbarSupportedContent">
					<ul className="navbar-nav mx-auto mb-2 mb-lg-0">
						<li className="nav-item px-2 ms-0 ms-md-5">
							<a className="nav-link" href="#about">
								About
							</a>
						</li>
						<li className="nav-item px-2">
							<a className="nav-link" href="#ButHow">
								How It Works
							</a>
						</li>

						<li className="nav-item px-2">
							<a className="nav-link" href="#expmenu">
								Menu
							</a>
						</li>

						<li className="nav-item px-2">
							<a className="nav-link" href="#sustain">
								Sustainability
							</a>
						</li>
					</ul>
					<ul className="navbar-nav me-1">
						<li className="nav-item me-3 pt-2">
							<a className="nav-link" href="tel:+4746389345">

								<img src={call} /> +47 46 38 93 45

							</a>
						</li>
						{/* 		<li className="nav-item me-3">
							<button className="btn btn-primary" type="submit">
								Order Now
							</button>
						</li> */}
					</ul>
					<ul className="nav navbar-nav visible-xs">
						<li className="pull-right">
							<a href="tel:phone-number">
								<i className="glyphicon glyphicon-phone"></i>
							</a>
						</li>
						<li className="pull-right">
							<a href="#">
								<i className="glyphicon glyphicon-map-marker"></i>
							</a>
						</li>
					</ul>
				</div>
			</div>
		</nav>
	);
};
